(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-play.js') >= 0) return;  svs.modules.push('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-play.js');
"use strict";


const {
  cdn
} = svs.core.config.data.svsconfig;
const {
  getDisplayName,
  getProductClassName
} = svs.utils.products;
const {
  useDefinition
} = svs.components.tipsen.engine.utils;
const {
  productIds
} = svs.utils.products;
const {
  BrandCube
} = svs.components.lbUi.brandCube;
const {
  breakpoints,
  useMediaQuery,
  BREAKPOINT_SM,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const productsToIncludeDrawManager = ['Topptipset', 'Powerplay'];
const gameTypesText = {
  Topptipset: '8 fotbollsmatcher',
  Powerplay: '8 hockeymatcher',
  Europatipset: '13 fotbollsmatcher',
  Stryktipset: '13 fotbollsmatcher',
  Bomben: '2 till 4 matcher',
  Fullträff: '13 fotbollsmatcher',
  Matchen: 'en utvald match'
};
const eventTypeText = {
  default: 'Välj 1, X eller 2 . 1 betyder att hemmalaget vinner, X att det blir oavgjort och 2 att bortalaget vinner. Om du är du osäker på hur matchen slutar kan du klicka i två eller alla tre alternativ. Att välja två alternativ kallas att halvgardera och tre att helgardera.',
  Bomben: 'Välj minst ett alternativ per lag i varje match',
  Fullträff: 'Välj mellan 0, 1, 2, 3, 4, 5, 6, 7+ mål. Om du är osäker kan du klicka i flera alternativ och bygga vad som kallas för ett system.'
};
const eventTypeHeaderText = {
  Fullträff: 'Hur många mål tror du det blir i matchen?',
  default: 'Hur tror du det går i matchen?'
};
const overviewText = {
  Fullträff: 'I botten på sidan kan du se hur många matcher du tippat och priset för spelet.',
  default: 'I botten på sidan kan du se hur många matcher du tippat, antal hel- och halvgarderingar och priset för spelet.'
};
const TipsenPlay = () => {
  var _useDefinition$drawPr, _useDefinition;
  const productId = (_useDefinition$drawPr = (_useDefinition = useDefinition()) === null || _useDefinition === void 0 || (_useDefinition = _useDefinition.drawProductIds) === null || _useDefinition === void 0 ? void 0 : _useDefinition[0]) !== null && _useDefinition$drawPr !== void 0 ? _useDefinition$drawPr : undefined;
  const productName = getDisplayName(productId);
  const productImgName = getProductClassName(productId);
  const isMatchen = productId === productIds.MATCHEN;
  const isTablet = useMediaQuery(breakpoints.between(BREAKPOINT_SM, BREAKPOINT_MD));
  const brandCubeTabletSize = {
    '--size': '90px'
  };
  const shouldShowDrawManager = productsToIncludeDrawManager.includes(productName);
  return React.createElement("div", {
    className: "pg_tipsen_game_guide__play-content"
  }, React.createElement("div", {
    className: "pg_game_guide__content--img-container pg_game_guide__content--img-container-top"
  }, React.createElement(BrandCube, {
    productId: productId,
    style: isTablet ? brandCubeTabletSize : {}
  })), React.createElement("div", {
    className: "pg_game_guide__content--img-container pg_game_guide__content--img-container-bottom"
  }, React.createElement(BrandCube, {
    productId: productId,
    style: isTablet ? brandCubeTabletSize : {}
  })), React.createElement("div", {
    className: "pg_tipsen_game_guide__play"
  }, React.createElement("h2", {
    className: "pg_tipsen_game_guide__title"
  }, "Tippa resultatet i", React.createElement("br", null), gameTypesText[productName]), React.createElement("ol", {
    className: "pg_tipsen_game_guide__play__list"
  }, shouldShowDrawManager && React.createElement("li", {
    className: "pg_tipsen_game_guide__play__list__item"
  }, React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, "1"), React.createElement("h3", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, "Vilken spelomg\xE5ng vill du spela?"), React.createElement("img", {
    alt: "Omg\xE5ngsv\xE4ljare f\xF6r ".concat(productName),
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-draw-manager.svg")
  }), React.createElement("p", {
    className: "margin-bottom-3"
  }, "Klicka h\xE4r f\xF6r att se alla spelomg\xE5ngar")), isMatchen ? React.createElement("li", {
    className: "pg_tipsen_game_guide__play__list__item"
  }, React.createElement("h3", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, "S\xE5 spelar du"), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-1"
  }, 1), React.createElement("p", null, "V\xE4lj en match och ange antal m\xE5l f\xF6r hemma- respektive bortalaget."), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-1"
  }, 2), React.createElement("p", null, "V\xE4lj insats (10-500kr)."), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-1"
  }, 3), React.createElement("p", {
    className: "margin-bottom-3"
  }, "Betala")) : React.createElement("li", {
    className: "pg_tipsen_game_guide__play__list__item"
  }, React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, shouldShowDrawManager ? 2 : 1), React.createElement("h3", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, eventTypeHeaderText[productName] || eventTypeHeaderText.default), React.createElement("img", {
    alt: "Match i kupongen",
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-draw-event.svg")
  }), React.createElement("p", {
    className: "margin-bottom-3"
  }, eventTypeText[productName] || eventTypeText.default), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, shouldShowDrawManager ? 3 : 2), React.createElement("h3", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, "Vill du ha mer information och statistik om lagen?"), React.createElement("img", {
    alt: "Statistik f\xF6r matchen",
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-stats.svg")
  }), React.createElement("p", {
    className: "margin-top-2 margin-bottom-3"
  }, "Klicka p\xE5 lagnamnen s\xE5 visas mer information som till exempel statistik och spelanalys."), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, shouldShowDrawManager ? 4 : 3), React.createElement("h3", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, "Var hittar jag information om mitt spel?"), React.createElement("img", {
    alt: "\xD6versikt f\xF6r spel",
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-overview.svg")
  }), React.createElement("p", {
    className: "margin-top-2 margin-bottom-3"
  }, overviewText[productName] || overviewText.default), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, shouldShowDrawManager ? 5 : 4), React.createElement("h3", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, "Har du valt resultat i alla matcher?"), React.createElement("img", {
    alt: "Betalaknapp f\xF6r spelet",
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-betslip.svg")
  }), React.createElement("p", {
    className: "margin-top-2 margin-bottom-3"
  }, "N\xE4r du valt alternativ i alla matcher dyker betalknappen upp.")))));
};
setGlobal('svs.components.tipsen.gameGuideTipsen.TipsenPlay', TipsenPlay);

 })(window);